"use client"

import { useError } from "@/hooks/use-error"

export function FloatingError() {
  const { error } = useError()

  if (!error || error === "" || error === null) return null

  return (
    <div className="fixed left-0 right-0 top-0 z-[999] flex justify-center rounded-bl-xl rounded-br-xl border border-red-500/50 bg-mdf px-4 py-3 text-center text-sm font-medium text-white shadow-md md:py-4 md:text-base">
      <p>{error}</p>
    </div>
  )
}
